var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M9.218 3.043c-1.108-.265-1.41-.56-1.682-1.64a.312.312 0 0 0-.606 0c-.273 1.08-.574 1.375-1.682 1.64a.31.31 0 0 0-.24.296c0 .14.1.262.24.296 1.108.265 1.41.559 1.682 1.639a.313.313 0 0 0 .606 0c.272-1.08.574-1.374 1.682-1.64a.31.31 0 0 0 .24-.295c0-.141-.1-.263-.24-.296"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002,
  d: "m10.669 4.501.237.077c1.019.328 1.043 1.742.036 2.103l-2.815 1.01a.56.56 0 0 0-.337.333l-1.078 2.928c-.36.978-1.762.977-2.12-.002L1.738 3.163c-.327-.892.555-1.753 1.455-1.42l.783.288"
})));
export default SvgArrow;